import * as React from "react"
import { SFProIcon, SFProIconProps } from "./SFProIcon"

export interface CartIconProps extends Omit<SFProIconProps, 'symbol'> {}

/**
 * Cart icon using SF Pro font symbol (􀍪)
 *
 * This icon represents a shopping cart in the ANYW3AR app.
 * Used for "Buy This Item" actions that link to Shopify.
 *
 * @example
 * ```tsx
 * <CartIcon />
 * <CartIcon size={16} weight="semibold" />
 * ```
 */
export const CartIcon = React.forwardRef<HTMLSpanElement, CartIconProps>(
  (props, ref) => {
    return <SFProIcon ref={ref} symbol="􀍪" {...props} />
  }
)

CartIcon.displayName = "CartIcon"
